// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.time-options {
  margin: 20px;
}

ion-list {
  max-height: 300px; /* Adjust based on how many slots to show at a time */
  overflow-y: auto; /* Enable scrolling */
}

ion-item {
  padding: 10px;
}

ion-label {
  font-size: 16px;
}

ion-radio {
  margin-right: 10px;
}

ion-button {
  margin-top: 20px;
}

ion-button {
  --background: #8bc34a;
}`, "",{"version":3,"sources":["webpack://./src/app/components/edit-time-slot-selection/edit-time-slot-selection.component.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;AACJ;;AAEE;EACE,iBAAA,EAAA,qDAAA;EACA,gBAAA,EAAA,qBAAA;AACJ;;AAEE;EACE,aAAA;AACJ;;AAEE;EACE,eAAA;AACJ;;AAEE;EACE,kBAAA;AACJ;;AAEE;EACE,gBAAA;AACJ;;AACE;EACE,qBAAA;AAEJ","sourcesContent":[".time-options {\r\n    margin: 20px;\r\n  }\r\n  \r\n  ion-list {\r\n    max-height: 300px; /* Adjust based on how many slots to show at a time */\r\n    overflow-y: auto; /* Enable scrolling */\r\n  }\r\n  \r\n  ion-item {\r\n    padding: 10px;\r\n  }\r\n  \r\n  ion-label {\r\n    font-size: 16px;\r\n  }\r\n  \r\n  ion-radio {\r\n    margin-right: 10px;\r\n  }\r\n  \r\n  ion-button {\r\n    margin-top: 20px;\r\n  }\r\n  ion-button {\r\n    --background: #8bc34a;\r\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
